export const sortAlphabetize = (arr, value) => {
  return arr.sort((a, b) => a[value].localeCompare(b[value]))
}